import { getDefaultPagedContent } from '@src/common/types';
import { RiskScoreSearchApiResponse } from '../types';

export function getDefaultRiskScoreSearchResponse(): RiskScoreSearchApiResponse {
  return {
    content: [],
    ...getDefaultPagedContent(),
  };
}
